import axios from "axios";
import { userTypeApi } from '../_constants/api.constant'
import {  getSelfToken } from '../../_helpers/auth/secureToken'
export async function getUserType() {
    let prarmTempObj = {};
    const response = await axios.get(
        userTypeApi.VIEW,
        {
           /*  headers: {
                Authorization: 'Token ' + getSelfToken(),
            }, */
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        console.log(error);
        console.log(error.response);
        return error.response;
    });
    return response;
}